import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export const useWithdrawals = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWithdrawals = useCallback(async () => {
    setLoading(true);
    const response = await api.get('/withdrawals/all');

    if (!response?.ok) {
      setLoading(false);
      return;
    }

    const data = response.data?.data ?? response.data ?? [];
    setWithdrawals(Array.isArray(data) ? data : []);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchWithdrawals();
  }, [fetchWithdrawals]);

  return { data: withdrawals, loading, refetch: fetchWithdrawals };
};
